import React, { useEffect, useState } from 'react';
import { ref, getDownloadURL } from 'firebase/storage';
import { storage, db } from '../firebase';
import { useGlobalContext } from './GlobalStateContext';
import { collection, query, getDocs, orderBy } from 'firebase/firestore';
import LoadingAnimation from './LoadingAnimation';

const SasiReports = () => {
  const { selectedFeedlot, feedlots, handleFeedlotSelect } = useGlobalContext();
  const [pdfFiles, setPdfFiles] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    setPdfFiles([])
    if (selectedFeedlot && selectedFeedlot.SarCompID) {
      fetchPdfFiles(selectedFeedlot.SarCompID);
    }
  }, [selectedFeedlot]);

  const fetchPdfFiles = async (sarCompID) => {
    setLoading(true);
    setError(null);
    const pdfList = [];
    try {
      const pdfDatesRef = collection(db, sarCompID, 'GeneralData', 'PDFDates');
      const pdfDatesQuery = query(pdfDatesRef, orderBy('date', 'desc')); // Ordering by the 'date' field
      const querySnapshot = await getDocs(pdfDatesQuery);

      querySnapshot.forEach(doc => {
        const data = doc.data();
        if (data.name && data.date) {
          pdfList.push(data.name);
        }
      });

      const pdfUrls = await Promise.all(
        pdfList.map(async (pdfName) => {
          const storageRef = ref(storage, `System.${sarCompID}/${pdfName}`);
          const url = await getDownloadURL(storageRef);
          return { name: pdfName, url };
        })
      );

      setPdfFiles(pdfUrls);
    } catch (error) {
      console.error('Error fetching PDF files:', error);
      setError('Failed to fetch PDF files. Please check the console for more details.');
    }
    setLoading(false);
  };

  const handleFeedlotChange = (event) => {
    const selectedFeedlotIndex = event.target.value;
    const selectedFeedlot = feedlots[selectedFeedlotIndex];
    handleFeedlotSelect({ target: { value: selectedFeedlotIndex } });
  };

  const sarCompFeedlots = feedlots.filter(feedlot => feedlot.SarCompID);

  return (
<div className="flex flex-col items-center bg-gray-900 text-white p-6 rounded-lg shadow-lg max-w-fullxl mx-auto">
  <h1 className="text-3xl font-bold mb-6">Your SASI Reports</h1>
  
  <div className="w-full mb-4">
    <label htmlFor="feedlotSelect" className="block text-lg mb-2">Select a Feedlot</label>
    <select
      className="cursor-pointer w-full p-3 rounded-md bg-gray-700 text-gray-200 shadow focus:ring-2 focus:ring-slate-500" 
      onChange={handleFeedlotSelect}
      value={selectedFeedlot ? feedlots.findIndex(feedlot => (feedlot.SarCompID === selectedFeedlot.SarCompID && feedlot.TMRID === selectedFeedlot.TMRID)) : ''}
    >
        <option value="">-- Select a Feedlot --</option>
        {feedlots.map((feedlot, index) => (
          <option key={index} value={index}>
            {feedlot.Name || `Feedlot ${index + 1}`}
          </option>
        ))}
      </select>
  </div>

  {loading ? (
    <div className="col-span-2 lg:col-span-4 m-10 flex justify-center items-center">
      <LoadingAnimation />
    </div>
  ) : error ? (
    <p className="text-lg text-red-500">{error}</p>
  ) : pdfFiles.length > 0 ? (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 gap-4 w-full">
      {pdfFiles.map((file) => (
        <a
          key={file.name}
          href={file.url}
          target="_blank"
          rel="noopener noreferrer"
          className="bg-gray-800 rounded-lg p-4 transition-transform transform hover:scale-105 hover:bg-gray-700 duration-300 flex items-center justify-center"
        >
          <div className="text-center text-white-400">
            {file.name}
          </div>
        </a>
      ))}
    </div>
  ) : selectedFeedlot != null ?  (
        <div className="col-span-2 md:col-span-3 lg:col-span-4 bg-red-200 text-red-700 p-4 rounded-lg shadow-3xl flex items-center">
          <svg className='className="w-6 h-6 text-gray-100 mr-2' viewBox="0 0 24 24" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title>alert_fill</title> <g id="页面-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd"> <g id="System" transform="translate(-286.000000, -240.000000)"> <g id="alert_fill" transform="translate(286.000000, 240.000000)"> <path d="M24,0 L24,24 L0,24 L0,0 L24,0 Z M12.5934901,23.257841 L12.5819402,23.2595131 L12.5108777,23.2950439 L12.4918791,23.2987469 L12.4918791,23.2987469 L12.4767152,23.2950439 L12.4056548,23.2595131 C12.3958229,23.2563662 12.3870493,23.2590235 12.3821421,23.2649074 L12.3780323,23.275831 L12.360941,23.7031097 L12.3658947,23.7234994 L12.3769048,23.7357139 L12.4804777,23.8096931 L12.4953491,23.8136134 L12.4953491,23.8136134 L12.5071152,23.8096931 L12.6106902,23.7357139 L12.6232938,23.7196733 L12.6232938,23.7196733 L12.6266527,23.7031097 L12.609561,23.275831 C12.6075724,23.2657013 12.6010112,23.2592993 12.5934901,23.257841 L12.5934901,23.257841 Z M12.8583906,23.1452862 L12.8445485,23.1473072 L12.6598443,23.2396597 L12.6498822,23.2499052 L12.6498822,23.2499052 L12.6471943,23.2611114 L12.6650943,23.6906389 L12.6699349,23.7034178 L12.6699349,23.7034178 L12.678386,23.7104931 L12.8793402,23.8032389 C12.8914285,23.8068999 12.9022333,23.8029875 12.9078286,23.7952264 L12.9118235,23.7811639 L12.8776777,23.1665331 C12.8752882,23.1545897 12.8674102,23.1470016 12.8583906,23.1452862 L12.8583906,23.1452862 Z M12.1430473,23.1473072 C12.1332178,23.1423925 12.1221763,23.1452606 12.1156365,23.1525954 L12.1099173,23.1665331 L12.0757714,23.7811639 C12.0751323,23.7926639 12.0828099,23.8018602 12.0926481,23.8045676 L12.108256,23.8032389 L12.3092106,23.7104931 L12.3186497,23.7024347 L12.3186497,23.7024347 L12.3225043,23.6906389 L12.340401,23.2611114 L12.337245,23.2485176 L12.337245,23.2485176 L12.3277531,23.2396597 L12.1430473,23.1473072 Z" id="MingCute" fill-rule="nonzero"> </path> <path d="M15.3137,2 C15.8441,2 16.3529,2.21071 16.7279,2.58579 L21.4142,7.27208 C21.7893,7.64715 22,8.15586 22,8.68629 L22,15.3137 C22,15.8441 21.7893,16.3529 21.4142,16.7279 L16.7279,21.4142 C16.3528,21.7893 15.8441,22 15.3137,22 L8.68629,22 C8.15586,22 7.64715,21.7893 7.27208,21.4142 L2.58579,16.7279 C2.21071,16.3528 2,15.8441 2,15.3137 L2,8.68629 C2,8.15586 2.21071,7.64715 2.58579,7.27208 L7.27208,2.58579 C7.64715,2.21071 8.15586,2 8.68629,2 L15.3137,2 Z M12,15 C11.4477,15 11,15.4477 11,16 C11,16.5523 11.4477,17 12,17 C12.5523,17 13,16.5523 13,16 C13,15.4477 12.5523,15 12,15 Z M12,6 C11.48715,6 11.0644908,6.38604429 11.0067275,6.88337975 L11,7 L11,13 C11,13.5523 11.4477,14 12,14 C12.51285,14 12.9355092,13.613973 12.9932725,13.1166239 L13,13 L13,7 C13,6.44772 12.5523,6 12,6 Z" id="形状" fill="#e81127"> </path> </g> </g> </g> </g></svg>
          No data is available for the selected feedlot. Please choose a different feedlot or contact our office for assistance.
        </div>
      ) :(
        <div></div>
      )} 
</div>


  );
};

export default SasiReports;
